import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

/*Services*/
import { BaseHttpService } from '@services/http/base-http.service';
import { CachedDataService } from '@services/data/cached-data.service';
import { AuthService, } from '@services/http/auth.service';
import { AppService } from '@services/app.service';

/*Environment */
import { environment } from '@environments';


/*Models */
import { Tariff, GetTarifsResponse, GetOrdersResponse } from '@models';

/*Plugins */
import * as moment from 'moment';

@Injectable()
export class TariffService extends BaseHttpService {

  constructor(protected httpClient: HttpClient,
    protected cachedDataService: CachedDataService,
    protected router: Router,
    protected authService: AuthService,
    private appService: AppService
  ) {
    super(httpClient, cachedDataService, router, authService);
  }
  getInfoSim(userId: string): Observable<GetTarifsResponse> {
    const uri = environment.apiUri + 'simCardData/search';
    const params = new HttpParams()
      .set('userId', userId);
    return super.send('GET', uri, params);
  }
  getTariffUrlPayment(tariffList: Array<Tariff>): Observable<any> {
    let body:Array<Object> = []
    tariffList.map(tariff=>{
      let startServiceDate;
      let endServiceDate;
  
      const userDateTimeOffset = this.appService.userTimezoneOffset();
      const currentDateInix = moment().startOf('day').add(userDateTimeOffset, 'hours').unix();
  
      if (currentDateInix > tariff.finishDate) {
        /*Если просроченный тариф */
        startServiceDate = currentDateInix;
        endServiceDate = moment.unix(currentDateInix).add(1, 'year').unix();
      } else {
        /*Если тариф еще действует*/
        startServiceDate = tariff.finishDate;
        endServiceDate = moment.unix(tariff.finishDate).add(1, 'year').unix();
      }

      body.push({
        'number': tariff.number,
        'serviceType': 'prolongation',
        'StartServiceDate': startServiceDate,
        'EndServiceDate': endServiceDate
      });
  
    })
   
    const uri = environment.apiUri + 'simCardData/order';
  
    return super.send('POST', uri, null, true, body);
  }
  seriveceOrder(number: string, serviceType: string, startServiceDate: number, endServiceDate: number): Observable<any> {
    let body:Array<Object> = []
      body.push({
        'number': number,
        'serviceType': serviceType,
        'StartServiceDate': startServiceDate,
        'EndServiceDate': endServiceDate
      });
      console.log(body)
   
    const uri = environment.apiUri + 'simCardData/order';
  
    return super.send('POST', uri, null, true, body);
  }

  getSerivecesOrders(serviceType: string, userId: string): Observable<GetOrdersResponse> {


     const uri = environment.apiUri +'simCardData/order/search';
    const params = new HttpParams()
      .set('serviceType', serviceType)
      .set('userId', userId);
      

    return super.send('GET', uri, params);
  }

  getTariff(tariffs, device, userId?) {
    let phoneDevice = device.phones.filter(phone => phone.usageType == "main")[0];
    if (phoneDevice) {
      phoneDevice = phoneDevice.number;
    } else {
      return false;
    }

    const tariffDevice = tariffs.filter(tariff => tariff.number === phoneDevice)[0];
    if (tariffDevice) {
      if(tariffDevice.finishDate){
        tariffDevice['dateFormat'] = moment.unix(tariffDevice.finishDate).format('DD.MM.YY');
      }else{
        tariffDevice['dateFormat']  = "-"
      }
      
      return tariffDevice;
    } else {
      return false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/tariff.services.ts